import(/* webpackMode: "eager" */ "/usr/server/app/apps/pcc-nextjs-bff/app/[lang]/[esite]/(core)/parts-diagram/_components/parts-layout/parts-layout.module.scss");
;
import(/* webpackMode: "eager" */ "/usr/server/app/apps/pcc-nextjs-bff/components/blocks-components.tsx");
;
import(/* webpackMode: "eager" */ "/usr/server/app/apps/pcc-nextjs-bff/components/skeleton-breadcrumbs/skeleton-breadcrumbs.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/server/app/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
